export default {
  SHAPES: {
    CIRCLE: "circle",
    SQAURE: "square",
  },
};
